import { memo, useEffect } from 'react'
// import { Button } from '../ui/button'
// import { Separator } from '../ui/separator'
import { cn } from '../../lib/utils'
import { useTagsStore } from '../../store/tagsStore'
// import { useNotesStore } from '../../store/notesStore'
import { NoteList, NoteListRef } from './NoteList'
// import {
//   FileText,
//   Tag,
//   Trash2,
//   Lock,
//   Plus
// } from 'lucide-react'

interface SidebarProps {
  className?: string
  style?: React.CSSProperties
  noteListRef?: React.RefObject<NoteListRef>
}

export const Sidebar = memo(({ className, style, noteListRef }: SidebarProps) => {
  const { fetchTags, updateTagNoteCounts } = useTagsStore()
  // const { notes, setSearchQuery } = useNotesStore()

  // Load tags on mount
  useEffect(() => {
    fetchTags()
    updateTagNoteCounts()
  }, [fetchTags, updateTagNoteCounts])

  // Calculate counts
  // const allNotesCount = notes.filter(note => !note.is_trashed).length
  // const lockedNotesCount = notes.filter(note => note.is_locked && !note.is_trashed).length
  // const trashedNotesCount = notes.filter(note => note.is_trashed).length
  // const taggedNotesCount = notes.filter(note => 
  //   !note.is_trashed && 
  //   // This would need to be implemented with actual tag relationships
  //   false // Placeholder for now
  // ).length

  // const handleTagClick = (tagName: string) => {
  //   // Filter notes by tag - for now just search for the tag name
  //   setSearchQuery(`#${tagName}`)
  // }

  // const handleViewClick = (type: string) => {
  //   switch (type) {
  //     case 'all':
  //       setSearchQuery('')
  //       break
  //     case 'locked':
  //       // TODO: Implement locked notes filter
  //       break
  //     case 'trash':
  //       // TODO: Implement trash view
  //       break
  //     default:
  //       break
  //   }
  // }

  return (
    <aside 
      className={cn(
        "border-r border-border bg-muted/20 flex flex-col transition-all duration-300",
        className
      )}
      style={style}
    >
      {/* Navigation */}
      {/* <div className="flex-shrink-0 p-4 space-y-2">
        <div className="space-y-1">
          <Button 
            variant="ghost" 
            className="w-full justify-start gap-2" 
            size="sm"
            onClick={() => handleViewClick('all')}
          >
            <FileText className="h-4 w-4" />
            All Notes
            <span className="ml-auto text-xs text-muted-foreground">{allNotesCount}</span>
          </Button>
          <Button 
            variant="ghost" 
            className="w-full justify-start gap-2" 
            size="sm"
            onClick={() => handleViewClick('tagged')}
          >
            <Tag className="h-4 w-4" />
            Tagged
            <span className="ml-auto text-xs text-muted-foreground">{taggedNotesCount}</span>
          </Button>
          <Button 
            variant="ghost" 
            className="w-full justify-start gap-2" 
            size="sm"
            onClick={() => handleViewClick('locked')}
          >
            <Lock className="h-4 w-4" />
            Locked
            <span className="ml-auto text-xs text-muted-foreground">{lockedNotesCount}</span>
          </Button>
          <Button 
            variant="ghost" 
            className="w-full justify-start gap-2" 
            size="sm"
            onClick={() => handleViewClick('trash')}
          >
            <Trash2 className="h-4 w-4" />
            Trash
            <span className="ml-auto text-xs text-muted-foreground">{trashedNotesCount}</span>
          </Button>
        </div>

        <Separator className="my-4" /> */}

        {/* Tags Section */}
        {/* <div className="space-y-2">
          <div className="flex items-center justify-between px-2">
            <h3 className="text-sm font-medium text-muted-foreground">Tags</h3>
            <Button 
              variant="ghost" 
              size="sm" 
              className="h-6 w-6 p-0"
              title="Manage tags"
            >
              <Plus className="h-3 w-3" />
            </Button>
          </div>
          
          <div className="space-y-1 max-h-32 overflow-y-auto">
            {tags.length === 0 ? (
              <div className="px-2 py-2 text-center">
                <p className="text-xs text-muted-foreground">No tags yet</p>
              </div>
            ) : (
              [...tags]
                .sort((a, b) => b.note_count - a.note_count) // Sort by note count
                .map((tag) => (
                  <Button 
                    key={tag.id}
                    variant="ghost" 
                    className="w-full justify-start gap-2 h-8" 
                    size="sm"
                    onClick={() => handleTagClick(tag.name)}
                  >
                    <div 
                      className="w-3 h-3 rounded-full flex-shrink-0" 
                      style={{ backgroundColor: tag.color }}
                    />
                    <span className="flex-1 truncate text-left">{tag.name}</span>
                    <span className="text-xs text-muted-foreground">
                      {tag.note_count}
                    </span>
                  </Button>
                ))
            )}
          </div>
        </div>
      </div> */}

      {/* <Separator /> */}

      {/* Notes List */}
      <div className="flex-1 overflow-hidden">
        <NoteList ref={noteListRef} className="h-full" />
      </div>
    </aside>
  )
})
